import React from 'react';
import PropTypes from 'prop-types';
import { Grid, GridItem, Badge, GridCell, GridRow } from '@sitebase/ui-kit';
import { withTranslator } from '@wh/ui-translations';
import slugifier from '@wh/slugifier';

import './changeComponentList.scss';

const DATE_FORMAT = { weekday: 'short', month: 'short', day: 'numeric' };
const TIME_FORMAT = { hour: '2-digit', minute: '2-digit' };

const getTimezonePosition = (dateString) => {
    const timeDelimiterPosition = dateString.indexOf('T');
    let position = dateString.indexOf('-', timeDelimiterPosition);
    if (position === -1 && dateString.indexOf('+', timeDelimiterPosition) > -1) {
        position = dateString.indexOf('+', timeDelimiterPosition);
    }
    return position;
};

/*
Due to the fact that Safari doesn't support date in the format of 2019-06-11T18:00:00.000+0000
we need to add colon to timezone part and make it like 2019-06-11T18:00:00.000+00:00
*/
const normalizeStartDateTime = (dateString) => {
    const timezoneIndex = getTimezonePosition(dateString);
    if (timezoneIndex > -1) {
        return dateString.slice(0, timezoneIndex + 3) + ':' + dateString.slice(timezoneIndex + 3);
    }
    return dateString;
};

const translateDate = (date, locale) => new Intl.DateTimeFormat(locale, DATE_FORMAT).format(date);

const renderDateLabel = (eventDate) => (
    <div styleName="change-component-modal__event-date">
        <span styleName="change-component-modal__event-day-title-wrapper">
            <span styleName="change-component-modal__event-day-title">{eventDate}</span>
        </span>
    </div>
);

const renderEventRow = (id, name, renderDate, active, href, time, onClickEventItem) => (
    <GridRow key={id}>
        <GridCell>
            <div styleName="change-component-modal__row">
                {renderDate}
                <GridItem href={href} active={active} onClick={(e) => onClickEventItem(e, href)}>
                    <div styleName="change-component-modal__event">
                        <span styleName="change-component-modal__event-time">{time}</span>
                        <span styleName="change-component-modal__event-name">{name}</span>
                    </div>
                </GridItem>
            </div>
        </GridCell>
    </GridRow>
);

const renderEventList = (events, currentEventId, sportName, locale, t, onClickEventItem) => {
    const currentLocalDate = new Date().toLocaleDateString();
    let previousDate = null;

    return events.map(({ id, name, startDateTime, inPlay }) => {
        const date = new Date(normalizeStartDateTime(startDateTime));
        const localeDate = date.toLocaleDateString();
        const localeTimeString = date.toLocaleTimeString([], TIME_FORMAT);
        const time = inPlay ? (
            <Badge outfit="green">
                <span styleName="change-component-modal__badge">{t('common')('live')}</span>
            </Badge>
        ) : (
            localeTimeString
        );
        const href = `/betting/${locale}/${slugifier(sportName)}/${id}/${slugifier(name)}`;
        const active = id === currentEventId;
        let renderDate = null;

        if (previousDate !== localeDate) {
            previousDate = localeDate;
            const eventDate = currentLocalDate === localeDate ? t('common')('today') : translateDate(date, locale);
            renderDate = renderDateLabel(eventDate);
        }
        return renderEventRow(id, name, renderDate, active, href, time, onClickEventItem);
    });
};

const ChangeComponentList = ({ events, sportName, currentEventId, locale, t, onClickEventItem }) => (
    <Grid>{renderEventList(events, currentEventId, sportName, locale, t, onClickEventItem)}</Grid>
);

ChangeComponentList.propTypes = {
    events: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            inPlay: PropTypes.bool.isRequired,
            startDateTime: PropTypes.string.isRequired,
        })
    ).isRequired,
    sportName: PropTypes.string.isRequired,
    currentEventId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    onClickEventItem: PropTypes.func.isRequired,
};
export default withTranslator(ChangeComponentList);
